/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC} from "react";

import { StatisticsObjectType } from "../caseVolumeLineChart/types";


const CustomComponentDoctors: FC<StatisticsObjectType> = ({ StatisticsObjectType }): JSX.Element => {
  return (
    <div className="table-responsive">
      <table className="table table-sm">
        <thead className="table-light sticky-top">
        <tr className="text-center">
          <th>Providers</th>
          <th>DUROLANE</th>
          <th>GELSYN</th>
          <th>SUPARTZ</th>
          <th>Total Cases</th>
        </tr>
        </thead>
        <tbody>
        {StatisticsObjectType.doctors && StatisticsObjectType.doctors.length > 0 ?
          StatisticsObjectType.doctors.map((item, key) => {
            const durolane_total = item.plan_type_data.find((item) => item.drug_keys === "DUROLANE")
            const gelsyn_total = item.plan_type_data.find((item) => item.drug_keys === "GELSYN")
            const supartz_total = item.plan_type_data.find((item) => item.drug_keys.includes("SUPARTZ"))
            return (<tr className="text-center" key={key}>
              <td>
                <a
                  className="fw-normal fs-6 btn btn-link link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover p-0"
                >
                  {item.doctor_name}
                </a>
              </td>
              <td>{durolane_total?.count}</td>
              <td>{gelsyn_total?.count}</td>
              <td>{supartz_total?.count}</td>
              <td>{durolane_total?.cases_total}</td>
            </tr>)
          }) : null
        }
        </tbody>
      </table>
    </div>
  );
};

export default CustomComponentDoctors;
